<div id="sidebar" [ngClass]="{ 'collapsed': isCollapsed, 'sidebar-animate': allowWidthTransition }">
    <button class="sidebar-toggle-btn" type="button" (click)="toggleSidebar()" [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#22C063" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sidebar-toggle-icon" [ngClass]="{ 'reverse': isCollapsed }">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <path d="M9 6l6 6l-6 6"></path>
        </svg>
    </button>

    <ul class="sidebar-nav" (scroll)="onSidebarNavScroll()">
        <!-- Mobile: mirror header nav items inside sidebar -->
        <li class="mobile-header-link">
            <a href="/home" [class.active]="isHomeActive()" (click)="goToHome($event)" data-label="Home" aria-label="Home">
                <i class="bi bi-house me-2"></i>
                <span>Home</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.basic_search_permission !== false">
            <a routerLink="/basic-search" routerLinkActive="active" data-label="Basic Search" aria-label="Basic Search">
                <i class="bi bi-phone me-2"></i>
                <span>Basic Search</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.face_search_permission || subscription?.osint_search_permission">
            <a href="/osint-number-search" [class.active]="isOsintSearchActive()" (click)="goToOsintSearch($event)" data-label="Osint Search" aria-label="Osint Search">
                <i class="bi bi-search me-2"></i>
                <span>Osint Search</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.link_analysis_permission !== false">
            <a routerLink="/link-analysis" routerLinkActive="active" data-label="Link Analysis" aria-label="Link Analysis">
                <i class="bi bi-diagram-3 me-2"></i>
                <span>Link Analysis</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.face_search_permission || subscription?.face_compare_permission || subscription?.video_scanner_permission">
            <a routerLink="/osint-image-search" routerLinkActive="active" data-label="Face Search" aria-label="Face Search">
                <i class="bi bi-person-bounding-box me-2"></i>
                <span>Face Search</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.leak_search_permission">
            <a routerLink="/leak-number-search" routerLinkActive="active" data-label="Leak Search" aria-label="Leak Search">
                <i class="bi bi-shield-exclamation me-2"></i>
                <span>Leak Search</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.link_shortener_permission">
            <a routerLink="/generate-tracking-link" routerLinkActive="active" data-label="FasTrak" aria-label="FasTrak">
                <i class="bi bi-link-45deg me-2"></i>
                <span>FasTrak</span>
            </a>
        </li>
        <li class="mobile-header-link" *ngIf="subscription?.name_search_permission">
            <a routerLink="/advanced-search" routerLinkActive="active" data-label="Advanced Search" aria-label="Advanced Search">
                <i class="bi bi-sliders me-2"></i>
                <span>Advanced Search</span>
            </a>
        </li>
        <li class="mobile-header-link">
            <a routerLink="/user-account" routerLinkActive="active" data-label="My Account" aria-label="My Account">
                <i class="bi bi-person-circle me-2"></i>
                <span>My Account</span>
            </a>
        </li>
        <li class="mobile-header-divider"></li>

        <!-- Desktop: these live in the navbar apps launcher. Mobile keeps them here. -->
        <li class="sidebar-apps-item" *ngIf="subscription?.pan_search_permission">
            <a routerLink="/pan-search" routerLinkActive="active" data-label="PAN Search" aria-label="PAN Search">
                <i class="bi bi-person-badge me-2"></i>
                <span>PAN Search</span>
            </a>
        </li>
        <li *ngIf="subscription?.gst_search_permission">
            <a routerLink="/gst-search" routerLinkActive="active" data-label="GST to mobile number" aria-label="GST to mobile number">
                <i class="bi bi-building me-2"></i>
                <span>GST to mobile number</span>
            </a>
        </li>
        <li *ngIf="subscription?.din_search_permission">
            <a routerLink="/din-search" routerLinkActive="active" data-label="Din to mobile number" aria-label="Din to mobile number">
                <i class="bi bi-person-vcard me-2"></i>
                <span>Din to mobile number</span>
            </a>
        </li>
        <li *ngIf="subscription?.mobile_pan_search_permission">
            <a routerLink="/mobile-pan-search" routerLinkActive="active" data-label="Mobile to PAN number" aria-label="Mobile to PAN number">
                <i class="bi bi-phone-vibrate me-2"></i>
                <span>Mobile to PAN number</span>
            </a>
        </li>
        <li class="sidebar-apps-item" *ngIf="subscription?.phonepe_fastag_search_permission">
            <a routerLink="/phonepe-fastag-search" routerLinkActive="active" data-label="Fastag Search" aria-label="Fastag Search">
                <i class="bi bi-truck me-2"></i>
                <span>Fastag Search</span>
            </a>
        </li>
        <li *ngIf="subscription?.phonepe_upi_search_permission">
            <a routerLink="/phonepe-upi-search" routerLinkActive="active" data-label="UPI ID to Bank Details" aria-label="UPI ID to Bank Details">
                <i class="bi bi-phone me-2"></i>
                <span>UPI ID to Bank Details</span>
            </a>
        </li>
        <li class="sidebar-apps-item" *ngIf="subscription?.vehicle_search_permission">
            <a routerLink="/vehicle-search" routerLinkActive="active" data-label="Vehicle Search" aria-label="Vehicle Search">
                <i class="bi bi-car-front me-2"></i>
                <span>Vehicle Search</span>
            </a>
        </li>
        <li class="sidebar-apps-item" *ngIf="subscription?.virtual_number_permission">
            <a routerLink="/virtual-number" routerLinkActive="active" data-label="Virtual Number" aria-label="Virtual Number">
                <i class="bi bi-phone me-2"></i>
                <span>Virtual Number</span>
            </a>
        </li>
        <li class="sidebar-apps-item" *ngIf="subscription?.web_capture_permission">
            <a routerLink="/web-capture" routerLinkActive="active" data-label="Web Capture" aria-label="Web Capture">
                <i class="bi bi-globe2 me-2"></i>
                <span>Web Capture</span>
            </a>
        </li>
        <li>
            <a routerLink="/contact-directory" routerLinkActive="active" data-label="Nodal Contacts" aria-label="Nodal Contacts">
                <i class="bi bi-person-lines-fill me-2"></i>
                <span>Nodal Contacts</span>
            </a>
        </li>
        <li>
            <a routerLink="/search-history" routerLinkActive="active" data-label="History" aria-label="History">
                <i class="bi bi-clock-history me-2"></i>
                <span>History</span>
            </a>
        </li>
        <li>
            <a routerLink="/help" routerLinkActive="active" data-label="Help" aria-label="Help">
                <i class="bi bi-question-circle me-2"></i>
                <span>Help</span>
            </a>
        </li>
        <li>
            <a routerLink="/feedback" routerLinkActive="active" data-label="Feedback" aria-label="Feedback">
                <i class="bi bi-chat-left-dots me-2"></i>
                <span>Feedback</span>
            </a>
        </li>
    </ul>

    <div class="sidebar-floating-tooltip" [class.visible]="floatingTooltip.visible" [style.top.px]="floatingTooltip.top" [style.left.px]="floatingTooltip.left" aria-hidden="true">{{ floatingTooltip.label }}</div>

    <div class="sidebar-credits">
        <div class="sidebar-credits-remaining" [attr.data-label]="creditsLoading ? 'Remaining' : ('Remaining: ' + (availableCredits | creditsLabel))" [attr.title]="creditsLoading ? 'Loading remaining credits' : ('Remaining credits: ' + (availableCredits | creditsLabel))">
            <i class="bi bi-coin" aria-hidden="true"></i>
            <span class="sidebar-credits-label">Remaining</span>
            <strong class="sidebar-credits-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></strong>
        </div>
        <button type="button" class="sidebar-buy-credits-btn" data-label="Buy Credits" aria-label="Buy Credits" (click)="onBuyCreditsClick()">
            <i class="bi bi-coin" aria-hidden="true"></i>
            <span>Buy Credits</span>
        </button>
    </div>
</div>